import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';

import TagLabel from 'rebook/apps/base/components/TagLabel';

import EmptyCatalogDescription from './EmptyCatalogDescription';
import styles from './style.scss';

// trim all spaces before and after text paragraph
const transform = (node, index) => {
  const firstSymbol = get(node, 'data[0]', '');
  const isNewLineSymbol = firstSymbol === '\r' || firstSymbol === '\n';

  if ((node.prev || node.next) && !isNewLineSymbol) {
    return convertNodeToElement(node, index);
  }
  if (node.type === 'text') {
    return convertNodeToElement({ ...node, ...{ data: node.data.trim(' ') } });
  }
};

const CatalogDescription = ({ tags, description }) => {
  if (tags.length === 0 && !description) {
    <EmptyCatalogDescription />;
  }

  return (
    <React.Fragment>
      {tags.length > 0 && (
        <div className={styles.tags}>
          {tags.map((item, index) => (
            <Link
              to={{
                pathname: `/sets/`,
                state: { rubricInfo: item },
                search: `?rubric=${item.id}`,
              }}
              key={`${index}-${item.slug}`}>
              <TagLabel name={item.name} />
            </Link>
          ))}
        </div>)
      }
      {description && (
        <div className={styles.description}>{ReactHtmlParser(description, { transform })}</div>
      )}
    </React.Fragment>
  );
};

CatalogDescription.propTypes = {
  tags: PropTypes.array,
  description: PropTypes.string,
};

CatalogDescription.defaultProps = {
  tags: [],
  description: '',
};

export default CatalogDescription;
